import { useLanguage } from "@/context/LanguageContext";
import { APP_STORE_URL, PLAY_STORE_URL } from "@/data/content";

const AppleIcon = (props) => (
  <svg viewBox="0 0 384 512" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

const PlayIcon = (props) => (
  <svg viewBox="0 0 512 512" aria-hidden="true" {...props}>
    <path fill="#34a853" d="M61 35c-1 1 231 221 231 221l64-61L113 21c-19-11-41-9-52 14z" />
    <path fill="#4285f4" d="M48 60c0-10 5-19 13-24l231 220L61 481c-8-5-13-14-13-24z" />
    <path fill="#ea4335" d="M292 256l64-61 84 48c20 12 20 38 0 50l-84 48z" />
    <path fill="#fbbc04" d="M292 256L61 481c11 18 30 19 48 9l247-141z" />
  </svg>
);

const StoreButton = ({ Icon, top, bottom, href, testId, compact }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`group inline-flex items-center gap-3 rounded-2xl border border-[var(--line-strong)] bg-black/50 backdrop-blur transition-all duration-300 hover:border-[var(--sage)]/60 hover:bg-black/70 ${
      compact ? "px-4 py-2.5" : "px-5 py-3"
    }`}
  >
    <Icon className="shrink-0 text-white" style={{ width: compact ? 22 : 26, height: compact ? 22 : 26 }} />
    <span className="text-left leading-none">
      <span className="block text-[10px] uppercase tracking-wide text-[var(--ink-2)]">{top}</span>
      <span className={`block font-semibold text-white ${compact ? "text-sm" : "text-base"}`}>{bottom}</span>
    </span>
  </a>
);

export const AppStoreButtons = ({ className = "", idPrefix = "hero", compact = false }) => {
  const { t } = useLanguage();
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <StoreButton
        Icon={AppleIcon}
        href={APP_STORE_URL}
        top={t.appstore.ios.top}
        bottom={t.appstore.ios.bottom}
        testId={`${idPrefix}-app-store-btn`}
        compact={compact}
      />
      <StoreButton
        Icon={PlayIcon}
        href={PLAY_STORE_URL}
        top={t.appstore.android.top}
        bottom={t.appstore.android.bottom}
        testId={`${idPrefix}-google-play-btn`}
        compact={compact}
      />
    </div>
  );
};
